export default __webpack_public_path__ + "static/media/copyurl-black.956982d9.svg";